const potemplateType = {
  GET_PO_TEMPLATE: 'GET_PO_TEMPLATE',
  GET_PREVIEW_DATA: 'GET_PREVIEW_DATA',
  GET_EDIT_DATA: 'GET_EDIT_DATA',
  UPDATED_COMP: 'UPDATED_COMP',
  UPDATED_FACT: 'UPDATED_FACT',
  UPDATED_CUSTOM: 'UPDATED_CUSTOM',
  CLEAR_DATA: 'CLEAR_DATA',
};

export default potemplateType;
